export default [
  {
    path: '/funcionario-edit/:id',
    name: 'Editarfuncionário',
    component: () => import('./FuncionarioForm'),
    meta: {
      routerBack: '/funcionario',
      domain: 'Funcionario',
      sidebar: false,
      icon: 'keyboard_backspace',
      title: 'Editar funcionário',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Funcionario/FuncionarioForm/FuncionarioFormRouter.js